import { inject, Injectable } from '@angular/core';
import { GtmEvent } from '@shared/services/data-layer/models';
import { LogsService } from '@shared/services/logs';
import { LogLevel } from '@shared/services/logs/enums';
import { PlatformContextService } from '@shared/services/platform-context';

@Injectable({ providedIn: 'root' })
export class DataLayerService {
  private readonly isServer = inject(PlatformContextService).isServer();
  private readonly logs = inject(LogsService);

  private get dataLayer(): Partial<GtmEvent>[] | null {
    if (this.isServer) return null;

    const w = globalThis as unknown as { dataLayer?: Partial<GtmEvent>[] };
    w.dataLayer ??= [];

    return w.dataLayer ?? null;
  }

  push(payloadOrArray: Partial<GtmEvent> | Partial<GtmEvent>[]): boolean {
    const dl = this.dataLayer;
    if (!dl) {
      return false;
    }

    const items = Array.isArray(payloadOrArray) ? payloadOrArray : [payloadOrArray];

    const validItems: Partial<GtmEvent>[] = [];
    for (const item of items) {
      if (item && typeof item === 'object' && !Array.isArray(item)) {
        validItems.push({ button_text_value: undefined, ...item });
      } else {
        this.logs.warn('🏷️ DataLayerService', 'Invalid payload ignored:', item);
      }
    }

    if (validItems.length === 0) return false;

    this.logs.groupStart(LogLevel.DEBUG, false, '🏷️ DataLayerService', 'Pushed to dataLayer');
    for (const it of validItems) {
      dl.push(it);
      this.logs.debug('', it);
    }
    this.logs.groupEnd(LogLevel.DEBUG);
    return true;
  }
}
